/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Census-backed location candidate that can be validated and saved as Home.
 */
export type WeatherLocationSearchResult = {
    kind: WeatherLocationSearchResult.kind;
    label: string;
    latitude: number;
    longitude: number;
    source: string;
    sourceId: string;
    sourceVintage: string;
    approximate: boolean;
};
export namespace WeatherLocationSearchResult {
    export enum kind {
        PLACE = 'place',
        ZCTA = 'zcta',
    }
}

